import React from "react";
import Hero from "../../components/medical/Hero";
import HighlightedContactSection from "../../components/HighlightedContactSection";

const PARAGRAPH_CLASS =
  "mt-3 text-sm leading-relaxed text-gray-700 md:text-base";

const SECTIONS = [
  {
    id: "section-geschichte-gruender",
    leftLabel: "DER GRÜNDER",
    heading: "Karl Engels – vom Vertrieb zur Personalberatung",
    paragraphs: [
      "Der Zug der beruflichen Laufbahn führte den Wirtschaftsingenieur Karl Engels mit seinen Fähigkeiten in den Vertrieb. Er hat für Betriebe aller Größenordnungen bis hin zum „Global Player\" alle Rankings angeführt und für verschiedene amerikanische Produkte in unterschiedlichen Branchen den Markt geöffnet.",
      "Sehr bald nutzte er seine hohe Vertriebsaffinität, um diese an andere Menschen weiter zu geben, und neben der Arbeit an der „Verkäuferfront\" zunächst Vertriebstrainings zu halten. In der späteren Entwicklung wurde er dann auch damit betraut, neue Vertriebsmitarbeiter für Mandanten auszuwählen.",
      "Auch repräsentierte er seine Kundenvertriebsorganisationen im Zuge der Unternehmensberatung durch Vorträge bei internationalen Veranstaltungen; u. a. als Mitreferent vom ehemaligen Bundeskanzler Helmut Schmidt. Worauf wir besonders stolz sind!",
      "Er gründete 1981 die Karl Engels Personal und Unternehmensberatung.",
    ],
  },
  {
    id: "section-geschichte-marke",
    leftLabel: "WACHSTUM & MARKE",
    heading: "Von der Gründung zur Marke REPEXO",
    paragraphs: [
      "Das war 1981, inzwischen ist der Betrieb gewachsen und ein Stab, bestehend aus hoch qualifizierten Mitarbeitern, verstärkt die Teams. So ist die Firma des Gründers im Zuge der Firmenerweiterung inzwischen zur Marke geworden und heißt jetzt REPEXO GmbH & Co. KG.",
      "Für den Gründer war es wichtig, die Spezialisierung aufrecht zu erhalten und noch weiter auszubauen. Noch heute ist die REPEXO inhabergeführt und bedient mit ihren Spezialisten-Teams nicht nur den Sales-Markt, sondern ist eine international tätige Personalberatung, die sich methodenübergreifend mit dem Schwerpunkt der Direktansprache auf zwei weitere Marktsegmente spezialisiert hat. So bietet die REPEXO nicht nur die branchenspezifische Direktansprache – dem Executive Search von Kandidaten in den Branchen Sales, Engineering und dem Healthcare-Markt – an, sondern hat auch den Geschäftsbereich REPEXO Job-Consulting mit ihrem Karriereportal und der eingegliederten Karrierelounge, dem Kandidatenportal mit TOP-Kandidaten, ins Leben gerufen. Da nur ein kunden- und ergebnisorientiertes Vorgehen den gewünschten Sucherfolg bringt.",
    ],
  },
  {
    id: "section-geschichte-heute",
    leftLabel: "HEUTE",
    heading: "Fachleute und Nachfolge",
    paragraphs: [
      "In allen Units agieren Fachleute, die aus den speziellen Branchen heraus mit ihren Erfahrungswerten die Rekrutierungsprozesse so gestalten, dass die verschiedensten Mandanten zügig gute Mitarbeiter an Bord bekommen. Dabei bildet eine umfangreiche Beratung unserer Kunden den Grundstein für eine erfolgreiche und zufriedene Zusammenarbeit.",
      "Der Gründer Karl Engels ist nicht mehr aktiv im Tagesgeschäft tätig. Er hat das Geschäft vertrauensvoll in die Hände seiner Nachfolger gelegt.",
    ],
  },
];

export default function HistoryPage() {
  return (
    <>
      <Hero
        title="Geschichte"
        subheading="Über unsere Wurzeln und die Entwicklung der REPEXO."
      />
      <section className="bg-white pt-0 pb-16 md:pb-24">
        {SECTIONS.map((section, i) => (
          <div
            key={section.id}
            id={section.id}
            className="border-b border-gray-100 py-12 md:py-16 first:pt-8"
          >
            <div className="container-app mx-auto flex flex-col gap-8 px-4 md:flex-row md:gap-12 lg:gap-16">
              {section.leftLabel && (
                <div className="flex-shrink-0 md:w-36 lg:w-40">
                  <span className="detail-side-label text-xs font-semibold uppercase tracking-[0.2em] text-gray-700">
                    {section.leftLabel}
                  </span>
                </div>
              )}
              <div className="min-w-0 flex-1 max-w-4xl">
                <h2 className="text-2xl font-semibold leading-snug text-gray-900 md:text-3xl">
                  {section.heading}
                </h2>
                {section.paragraphs?.map((p, j) => (
                  <p key={j} className={PARAGRAPH_CLASS}>
                    {p}
                  </p>
                ))}
              </div>
            </div>
          </div>
        ))}
        <HighlightedContactSection
          heading="Mehr über REPEXO erfahren?"
          description="Wir beantworten gerne Ihre Fragen zur Geschichte und zu unseren Leistungen."
          buttonText="Jetzt Kontakt aufnehmen"
          sectionId="section-geschichte-contact"
        />
      </section>
    </>
  );
}
